function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["appElement", "style", "size", "className", "header", "closeButton", "closeOutside", "children", "onCancel", "isLoading", "isSubmitting"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { createContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { isEmpty } from "lodash-es";
import BaseModal from "react-modal";
import { useStateToRef } from "../../helpers/hooks";
import ModalHeader from "./ModalHeader";
import ModalFooter from "./ModalFooter";
import ModalBody from "./ModalBody";
import ModalSidebar from "./ModalSidebar";
export var Context = /*#__PURE__*/createContext({
  onCancel: function onCancel() {}
});
var Modal = function Modal(_ref) {
  var appElement = _ref.appElement,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "md" : _ref$size,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    _ref$header = _ref.header,
    header = _ref$header === void 0 ? "" : _ref$header,
    _ref$closeButton = _ref.closeButton,
    closeButton = _ref$closeButton === void 0 ? false : _ref$closeButton,
    _ref$closeOutside = _ref.closeOutside,
    closeOutside = _ref$closeOutside === void 0 ? true : _ref$closeOutside,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? /*#__PURE__*/React.createElement(ModalBody, null) : _ref$children,
    _ref$onCancel = _ref.onCancel,
    onCancel = _ref$onCancel === void 0 ? function () {} : _ref$onCancel,
    _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
    _ref$isSubmitting = _ref.isSubmitting,
    isSubmitting = _ref$isSubmitting === void 0 ? false : _ref$isSubmitting,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    height = _useState2[0],
    setHeight = _useState2[1];
  var onCancelRef = useStateToRef(onCancel);
  var heightRef = useStateToRef(height);
  useEffect(function () {
    var onKeyUp = function onKeyUp(event) {
      if (event.key === "Escape") {
        onCancelRef.current();
      }
    };
    var onResize = function onResize() {
      if (!["fullscreen", "quickbar"].includes(size)) return;
      var vh = window.innerHeight;
      var newHeight = "".concat(vh, "px");
      if (newHeight !== heightRef.current) {
        setHeight(newHeight);
      }
    };
    onResize();
    window.addEventListener("keyup", onKeyUp, false);
    window.addEventListener("resize", onResize, false);
    return function () {
      window.removeEventListener("keyup", onKeyUp, false);
      window.removeEventListener("resize", onResize, false);
    };
  }, [size]);
  return /*#__PURE__*/React.createElement(BaseModal, _extends({}, props, {
    overlayClassName: "modal-overlay",
    className: classNames("tui-modal ".concat(className, " ").concat(size), {
      "without-header": isEmpty(header)
    }),
    appElement: appElement || document.querySelector("div") || document.querySelector("body"),
    style: {
      content: _objectSpread(_objectSpread({}, style), {}, {
        height: height
      })
    },
    onRequestClose: onCancel,
    shouldCloseOnOverlayClick: closeOutside && !isLoading && !isSubmitting,
    aria: {
      busy: isLoading || isSubmitting
    }
  }), /*#__PURE__*/React.createElement(Context.Provider, {
    value: {
      onCancel: onCancel,
      isLoading: isLoading,
      isSubmitting: isSubmitting
    }
  }, header && /*#__PURE__*/React.createElement(ModalHeader, {
    closeButton: closeButton && !isLoading && !isSubmitting
  }, header), children));
};
Modal.propTypes = {
  appElement: PropTypes.object,
  isOpen: PropTypes.bool.isRequired,
  style: PropTypes.object,
  size: PropTypes.string,
  className: PropTypes.string,
  header: PropTypes.node,
  closeButton: PropTypes.bool,
  closeOutside: PropTypes.bool,
  children: PropTypes.node,
  onCancel: PropTypes.func,
  isLoading: PropTypes.bool,
  isSubmitting: PropTypes.bool
};
Modal.Header = ModalHeader;
Modal.Body = ModalBody;
Modal.Footer = ModalFooter;
Modal.Sidebar = ModalSidebar;
export default Modal;
//# sourceMappingURL=Modal.js.map